// removed by extract-text-webpack-plugin
module.exports = {"base":"Counter_base--iYSdu","current":"Counter_current--X5yBs","divider":"Counter_divider--2kt2z","total":"Counter_total--2s15K","reset":"Counter_reset--3dLwa","icon":"Counter_icon--2Wacc"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Counter/Counter.css
// module id = 1768
// module chunks = 16